<template>
  <div class="tweet">
    <div class="embed-col" :id="'embed-' + tweet.id">
      <div class="embed" :class="{'invisible': !isTweetLoaded}" v-html="tweetHtml"></div>
    </div>
    <div class="options-col">
      <div class="heading then-card">
        <img src="/images/icons/tw-like.svg" class="like-img" />
        <div class="like-label">{{ tweet.likes_count | likes }}</div>
        <div class="clearfix"></div>
      </div>
      <div class="heading then-card">
        <img src="/images/icons/tw-retweet.svg" class="retweet-img" />
        <div class="like-label">{{ tweet.retweets_count | retweets }}</div>
        <div class="clearfix"></div>
        <div class="retweet-reach">{{ tweet.retweets_reach | followers }} reached</div>
      </div>

      <template v-if="tweet.is_paid">
        <div class="embed-heading">Paid Promotion</div>
        <div class="embed-paid-status">
          <span class="status-em">{{ tweet.like_paid_spent_count }}</span>
          of {{ tweet.like_paid_count }} likes received
        </div>
        <div class="embed-paid-status">
          <span
            class="status-em"
          >{{ tweet.retweet_paid_spent_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</span>
          of {{ tweet.retweet_paid_count | followers }} reached
        </div>
      </template>
      <template v-if="disableTwitter">
        <div class="embed-heading">
          <div class="field-instructions">
            Due to the current rapidly changing environment at Twitter, we have disabled this feature.
              <br /> No new promotions are allowed at this time.
              <br />Thank you for your understanding!
          </div>
        </div>
      </template>
      <template v-else>
        <div class="embed-heading">
          Budget
          <div class="embed-heading-start-promotion" @click="clickPayNow">Start a Paid Promotion</div>
        </div>

        <div class="budget-line">
          <div class="input-label input-label-small">Likes</div>

          <div class="input-box input-box-small">
            <v-text-field
              v-model.trim="tweet.like_budget"
              placeholder="0 to 5,000 snaps"
              class="title-field"
            ></v-text-field>
            <div class="field-error" v-if="likesBudgetError">{{ likesBudgetError }}</div>
          </div>

          <div class="input-spent">
            <img src="/images/icons/snap.svg" class="earn-snaps-img" />
            <div class="earn-snaps-label">{{ tweet.likes_spent }} spent</div>
          </div>
        </div>

        <div class="budget-line">
          <div class="input-label input-label-small">Retweets</div>

          <div class="input-box input-box-small">
            <v-text-field
              v-model.trim="tweet.retweet_budget"
              placeholder="0 to 5,000 snaps"
              class="title-field"
            ></v-text-field>
            <div class="field-error" v-if="retweetsBudgetError">{{ retweetsBudgetError }}</div>
          </div>

          <div class="input-spent">
            <img src="/images/icons/snap.svg" class="earn-snaps-img" />
            <div class="earn-snaps-label">{{ tweet.retweets_spent }} spent</div>
          </div>
        </div>

        <div v-if="hasChanges" class="action save-button" @click="submitForm">Save</div>
      </template>

      <template v-if="isPayNowOpen">
        <div class="promote-option promote-option-paid" @click="clickPayNow">
          <div class="promote-option-title">Paid Promotion</div>
          <div class="promote-option-more">One-time payment of $14.99</div>
          <div class="promote-option-description">
            Receive 20 likes and reach 10,000 people
            through retweets on Twitter.
          </div>
          <div class="promote-option-pay" v-if="isPayNowOpen && paymentMethod">
            <div class="payment-line">
              Your
              {{ paymentMethod.card_brand }} card ending in
              <span
                style="font-weight: 600;"
              >{{ paymentMethod.card_last_four }}</span> will be charged
              <span style="font-weight:600;">$14.99</span>.
              <p
                style="padding-top: 12px; padding-bottom: 0; margin-bottom: 0;"
              >Members will see your tweet right away and be able to Like and Retweet it.</p>
            </div>
            <div @click="confirmPayNow" class="payment-button payment-button-later">Confirm Payment</div>
            <!-- <div @click="cancelPayNow" class="payment-button payment-button-cancel">Cancel</div> -->
            <div class="clearfix"></div>
          </div>
        </div>
      </template>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import Back from "../../modules/Back";
export default {
  name: "Tweet",
  props: ["tweet"],
  data: function() {
    return {
      tweetHtml: null,
      isTweetLoaded: false,
      likesBudgetError: null,
      retweetsBudgetError: null,
      originalLikeBudget: null,
      originalRetweetBudget: null,
      paymentMethod: null,
      isPayNowOpen: false,
      // diableTwitter: false,
    };
  },
  computed: {
    hasChanges() {
      return (
        this.originalLikeBudget !== this.tweet.like_budget ||
        this.originalRetweetBudget !== this.tweet.retweet_budget
      );
    },
    disableTwitter() {
      return process.env.VUE_APP_TWITTER_DISABLE==="true";
    }
  },
  created() {
    this.originalLikeBudget = this.tweet.like_budget;
    this.originalRetweetBudget = this.tweet.retweet_budget
  },
  mounted() {
    var that = this;
    jsonp(
      "https://publish.twitter.com/oembed?url=" + this.tweet.tw_url,
      function(data) {
        that.tweetHtml = data.html;
        that.isTweetLoaded = true;

        setTimeout(function() {
          twttr.widgets.load(document.getElementById("embed-" + that.tweet.id));
        }, 500);
      }
    );
  },
  methods: {
    async submitForm() {
      const response = await Back.saveTweet(this.tweet);

      console.log("submitForm", response);

      if (response) {
        this.$toasted.show(
          "Great! Your new budget for this tweet has been saved!",
          {
            icon: "check_circle",
            position: "bottom-center",
            duration: 3000
          }
        );
        this.originalLikeBudget = this.tweet.like_budget;
        this.originalRetweetBudget = this.tweet.retweet_budget;
        this.$emit("tweetSaved");
      } else {
        this.$toasted.show(
          "Oops! Something went wrong. Please try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000
          }
        );
      }
    },
    async clickPayNow() {
      this.isPayNowOpen = true;
      this.isUseSnapsOpen = false;

      if (!this.paymentMethod) {
        this.getUserPaymentMethod();
      }
    },
    async confirmPayNow() {
      const response = await Back.upPaidTweet(this.tweet.id);

      console.log("paid response", response);

      if (!response) {
        return this.$toasted.show(
          "Oops! Something went wrong. Please try again later or contact our support team.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 4000
          }
        );
      }

      if (response.message === "Tweet already promoted") {
        this.$toasted.show(
          "Oops! This tweet has already been promoted on Pubby.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000
          }
        );
      } else if (response) {
        this.$toasted.show(
          "Great! You started a paid promotion for this tweet!",
          {
            icon: "check_circle",
            position: "bottom-center",
            duration: 3000
          }
        );
        this.isTweetLoaded = false;
        this.tweetUrl = null;
        this.tweetHtml = "";
        this.likesBudget = null;
        this.retweetsBudget = null;
        this.isPayNowOpen = false;
        this.$emit("tweetSaved");
        this.$emit("tweetAdded");
      }
    },
    async getUserPaymentMethod() {
      const response = await Back.userPaymentMethod();

      if (!response) {
        this.$toasted.show(
          "Your payment method could not be found. Please contact our support team or try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 4000
          }
        );
      }

      this.paymentMethod = response;

      console.log("getUserPaymentMethod", response);
    }
  }
};

function jsonp(url, callback) {
  var callbackName = "jsonp_callback_" + Math.round(100000 * Math.random());
  window[callbackName] = function(data) {
    delete window[callbackName];
    document.body.removeChild(script);
    callback(data);
  };

  var script = document.createElement("script");
  script.src =
    url + (url.indexOf("?") >= 0 ? "&" : "?") + "callback=" + callbackName;
  document.body.appendChild(script);
}
</script>

<style lang="scss" scoped>
.tweet {
  padding: 16px 0 20px 40px;
}
.embed-col {
  float: left;
  width: 540px;
}
.options-col {
  float: left;
  width: 400px;
  padding-top: 30px;
}
.embed {
  color: #fff;
  a {
    color: #fff;
  }
}

.heading-budget {
  padding-top: 30px;
}

.input-label {
  float: left;
  width: 150px;
  min-width: 150px;
}
.input-box {
  float: left;
  width: 550px;
  font-family: $font-family;
}

.input-label {
  padding: 12px 12px 16px 0;
  font-size: 14pt;
  line-height: 1.4em;
  font-family: $font-family;
  color: darken($color-blue, 3%);
}
.input-label-small {
  width: 140px;
  padding-left: 32px;
  font-weight: 500;
}
.input-box-small {
  width: 100px !important;
  max-width: 100px !important;
}

.field-instructions {
  padding-bottom: 16px;
  font-size: 12.5pt;
  line-height: 1.4em;
  color: #777;
  font-family: $font-family;
}
.field-instructions-budget {
  padding-left: 20px;
}
.field-error {
  padding-bottom: 16px;
  font-size: 12.5pt;
  line-height: 1.4em;
  color: rgb(235, 96, 96);
}

.like-img {
  float: left;
  width: 24px;
  margin: 0px 8px 0 0;
}
.retweet-img {
  float: left;
  width: 25px;
  margin: 0px 8px 0 -1px;
}
.like-label {
  float: left;
  margin-top: 0px;
}

.retweet-reach {
  font-size: 13pt;
  color: #999;
  padding-left: 32px;
}

.save-button {
  margin: 12px 0 0 18px;
  background: #daedff;
  color: #2196f3;
}

.title-field {
  margin-top: 0px !important;
  width: 80px !important;
  font-size: 13.5pt;
}

.budget-line {
  display: flex;
  flex-direction: row;
}

.input-spent {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}
.earn-snaps-label {
  width: 102px;
  margin: 0px 0 0 6px;
  font-family: $font-family;
  font-size: 12pt;
  font-weight: 600;
  color: #ff7043;
}
.earn-snaps-img {
  width: 20px;
  margin: 0px 0 0 0px;
}

.v-text-field,
.title-field {
  padding-top: 8px !important;
}

.embed-heading {
  color: $color-blue;
  padding: 1.5em 0px 0.5em 31px;
  border-radius: 4px;
  font-size: 13.5pt;
  font-weight: 700;
  text-transform: none;
  font-family: "Source Sans Pro";
  text-transform: uppercase;
  text-align: left;
  letter-spacing: 1px;
}

.embed-heading-start-promotion {
  float: right;
  background: #daedff;
  color: #2196f3;
  border-radius: 24px;
  margin-top: -4px;
  padding: 4px 16px;
  text-transform: none;
  font-size: 12.5pt;
  letter-spacing: 0px;
}
.embed-heading-start-promotion:hover {
  background: lighten(#daedff, 2%);
  cursor: pointer;
}

.invisible {
  opacity: 0;
}

// Pay Now
.promote-option {
  margin-top: 12px;
  margin-bottom: 20px;
  padding: 16px 40px 16px 28px;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  border-radius: 8px;
  border-top: 4px solid $color-blue;
  font-family: $font-family;
}
.promote-option-title {
  font-size: 19pt;
  font-weight: 500;
  color: $color-blue;
}
.promote-option-more {
  font-size: 13.5pt;
  font-weight: 600;
  color: darken($color-blue, 0%);
}
.promote-option-description {
  padding-top: 0.5em;
  font-size: 12.5pt;
  font-weight: 500;
  line-height: 1.4em;
}

.promote-option-snaps {
  border-top: 4px solid $color-snaps;
  .promote-option-title {
    color: $color-snaps;
  }
}

.grow {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.payment-line {
  border-top: 1px solid #e3e3e3;
  border-bottom: 1px solid #e3e3e3;
  margin: 12px 0 16px 0;
  padding: 12px 0 16px 0;
  font-size: 12pt;
  font-weight: 500;
  color: #111;
  font-size: 12pt;
}

.payment-buttons {
  margin: 20px 4px;
}
.payment-button {
  float: left;
  margin-right: 8px;
  margin-bottom: 4px;
  font-size: 13pt;
  font-weight: 600;
  background: darken($color-blue, 4%);
  background: linear-gradient(
    0deg,
    $color-blue 0%,
    lighten($color-blue, 13%) 100%
  );
  border-radius: 4px;
  border: 2px solid darken($color-blue, 4%);
  border-bottom: 2px solid darken($color-blue, 7%);
  color: #fff;
  padding: 6px 18px;
  padding-top: 5px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  text-shadow: 2px 2px 1px rgba(17, 17, 17, 0.25);
  cursor: pointer;
}
.payment-button:hover {
  background: linear-gradient(
    0deg,
    darken($color-blue, 8%) 0%,
    lighten($color-blue, 5%) 100%
  );
}

.payment-button-cancel {
  background: #fff;
  border: 2px solid #fff;
  box-shadow: none !important;
  text-shadow: none !important;
  color: #999;
  border-radius: 6px;
  cursor: pointer;
  //text-decoration: underline;
}
.payment-button-cancel:hover {
  background: #f3f3f3;
  color: #888;
}
.payment-notice {
  padding: 7px 12px 0 14px;
  font-size: 12pt;
  font-weight: 500;
  color: #666;
}

.embed-paid-status {
  font-family: $font-family;
  color: darken($color-blue, 10%);
  color: #999;
  font-size: 12.5pt;
  font-weight: 600;
  padding: 0px 0 4px 50px;

  .status-em {
    color: #333;
  }
}
</style>
